<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>加入的圈子</span>
        <button v-if="listData.length > 0" class = "title_top_right_btn personal_add_btn rt" @click = "moreCircle">更多圈子</button>
      </p>
      <el-divider></el-divider>
    </div>
    <div class="my_circle"
    :class="listData.length === 0 ? 'my_none' : ''"
    v-loading="listLoading"
    element-loading-text="列表加载中"
    element-loading-spinner="el-icon-loading">
      <circle-view
      v-if="listData.length > 0"
      :list="listData"
      :type="type"
      :limit="listLimit"
      @retreat = "retreatBoard">
      </circle-view>
      <div v-if="listData.length === 0 && !listLoading" class="my_none">
         <img class="my_none_img" src="../../assets/img/user/joinCircleListNone.png" alt="加入圈子列表为空"><br/>
         <p class="my_none_user_text">
           <span>您暂未加入任何圈子！</span>
         </p>
         <button class = "personal_add_none_btn" @click.prevent = "moreCircle">更多圈子</button>
       </div>
    </div>
    <!-- 分页 -->
    <el-pagination
      v-if="listData.length > 0"
      background
      layout="prev, pager, next"
      :page-size= "listLimit"
      :total="listNum"
      @current-change = "pageChange">
    </el-pagination>
  </div>
</template>

<script>
import circle from '../Public/circle.vue'
export default {
  components: {
    circleView: circle
  },
  data () {
    return {
      listData: [], // 文章列表
      listNum: 0, // 文章总条目
      listLimit: 10, // 列表当前页显示条目数
      listPage: 1, // 列表当前页码
      listLoading: true, // 开启加载动画
      type: 'personalJoin'
    }
  },
  created () {
    this.pageChange()
  },
  methods: {
    // 更多圈子
    moreCircle () {
      const routeData = this.$router.resolve({
        path: '/circleList'
      })
      window.open(routeData.href, '_blank')
    },
    // 获取数据
    pageChange: function (index) {
      const vueThat = this
      if (index === undefined) {
        vueThat.listPage = 1
      } else {
        vueThat.listPage = index
      }
      const data = {
        limit: vueThat.listLimit,
        page: vueThat.listPage
      }
      vueThat.myApi.myJoinBoardList(data).then((res) => {
        if (res.data.code === 200) {
          vueThat.listLoading = false
          vueThat.listData = res.data.data.data
        }
      })
    },
    // 退出圈子
    retreatBoard (id, index, type) {
      const vueThat = this
      vueThat.$confirm('退出圈子后将无法获取圈子信息，是否确认退出圈子？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      }).then(() => {
        vueThat.myApi.retreatBoard({ board_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.$message({
              message: '退出圈子成功！',
              type: 'success'
            })
            vueThat.$set(vueThat.listData[index], 'is_join', 0)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
</style>
